var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorChoose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 30.9982L5.4666 26.5635C5.07744 25.8842 4.96753 25.0803 5.16008 24.3215C5.35263 23.5627 5.83256 22.9084 6.49851 22.4968C7.16447 22.0853 7.96431 21.9487 8.72911 22.1159C9.4939 22.2831 10.1638 22.741 10.5973 23.3928L12.9973 26.9928V11.9995C12.9973 11.2039 13.3133 10.4408 13.8759 9.87819C14.4386 9.31558 15.2016 8.99951 15.9973 8.99951C16.7929 8.99951 17.556 9.31558 18.1186 9.87819C18.6812 10.4408 18.9973 11.2039 18.9973 11.9995V22.9995H23.5026C24.9898 23.0713 26.3919 23.7147 27.4162 24.7954C28.4405 25.8761 29.0079 27.3106 28.9999 28.7995V31.0035",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.998535L31 7.99854",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.99854L31 0.998535",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.998535L5 7.99854L1 3.99854",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorChoose);
export default __webpack_public_path__ + "static/media/CursorChoose.8158eb6a2f5f7650801241cf833a1317.svg";
export { ForwardRef as ReactComponent };